module.exports = __webpack_public_path__ + "static/media/marshall.6b55a7d4.png";